import * as React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { RootStore, withInjectedRootStore } from 'providers';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { ErrorBoundary } from '../ErrorBoundaries/ErrorBoundary';
import { Notification } from '../Notification/Notification';
import { GlobalStyles } from '../App/GlobalStyles';
import { AppLayout } from './AppLayout';
import { BreakpointProvider } from 'providers/BreakpointProvider';
import { StickyHeaderHeightProvider } from 'providers/StickyHeaderHeightProvider';
import { Footer } from '../Footer/Footer';
import { Header } from './Header/Header';
import { useAppLoaded } from '../../hooks/useAppLoaded';
import appCss from '../App/App.scss';
import wixStudioCss from './WixStudioApp.scss';
import { ScrollRef } from 'components/ScrollRef/ScrollRef';
import { EnterpriseModalContextProvider } from 'providers/EnterpriseModalContextProvider';
import { ProductsGridRefContextProvider } from 'providers/ProductsGridContextRefProvider/ProductsGridContextRefProvider';
import { Experiments, PurchaseMode } from 'enums';

export interface WixStudioAppProps {
  rootStore: RootStore;
}

export const WixStudioAppComponent: React.FC<WixStudioAppProps> = ({
  rootStore: { appStore },
}) => {
  const { theme, purchaseMode, isChangePlan } = usePageModeContext();
  useAppLoaded(appStore);

  const isReplaceChangePlanPurchaseModeEnabled =
    appStore.experiments[Experiments.ReplaceChangePlanPurchaseMode] === 'true';

  const purchaseModeClassName =
    isChangePlan && isReplaceChangePlanPurchaseModeEnabled
      ? wixStudioCss[PurchaseMode.CHANGE_PLAN]
      : wixStudioCss[purchaseMode];

  return (
    <>
      <GlobalStyles />
      <>
        <BreakpointProvider>
          <StickyHeaderHeightProvider>
            <ScrollRef />
            <Notification />
            <Header />
            <ErrorBoundary>
              <EnterpriseModalContextProvider>
                <ProductsGridRefContextProvider>
                  <div
                    className={classNames(
                      appCss.mainContent,
                      wixStudioCss.container,
                      theme,
                      purchaseModeClassName,
                    )}
                  >
                    <AppLayout />
                    <Footer />
                  </div>
                </ProductsGridRefContextProvider>
              </EnterpriseModalContextProvider>
            </ErrorBoundary>
          </StickyHeaderHeightProvider>
        </BreakpointProvider>
      </>
    </>
  );
};

export const WixStudioApp = withInjectedRootStore(
  observer(WixStudioAppComponent),
);
